"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GetEnabledFeaturesError = void 0;
exports.getEnabledFeatures = getEnabledFeatures;
var _error = require("@ori/error");
var _logger = require("../logger");
var _getFeatureToggles = require("./getFeatureToggles");
const logger = _logger.mainLogger.createChild('getEnabledFeatures');
const GetEnabledFeaturesError = exports.GetEnabledFeaturesError = (0, _error.createCustomError)('GetEnabledFeaturesError', {
  NO_FEATURE_SPECIFIED: 'At least one feature must be specified to be fetched'
});
/**
 * Get a list of enabled features specified by `requestedFeatures`.
 *
 * From all existing features only those passed in `requestedFeatures` array (e.g. those that a consumer cares about) are picked.
 * Then from this list only those enabled are returned to optimize the size of the transferred data.
 * @param requestedFeatures List of features for which the enabled status is returned
 * @param options Configuration options
 * @returns A set of enabled features
 */
async function getEnabledFeatures(requestedFeatures, {
  apiClientOptions,
  tenant
}) {
  if (requestedFeatures.length === 0) {
    throw new GetEnabledFeaturesError('NO_FEATURE_SPECIFIED');
  }
  let toggles;
  try {
    toggles = await (0, _getFeatureToggles.getFeatureToggles)(apiClientOptions, tenant);
  } catch (error) {
    logger.error(new Error(`Some error occurred while getting feature toggles`, {
      cause: error
    }));
  }
  if (!toggles) {
    return [];
  }

  // only enabled features are left, false value is the same as when the feature doesn't exist
  const enabledFeatures = toggles.filter(toggle => toggle.isEnabled).reduce((accumulator, feature) => accumulator.add(feature.id ?? ''), new Set());
  return requestedFeatures.filter(feature => enabledFeatures.has(feature));
}
//# sourceMappingURL=getEnabledFeatures.js.map